import { useState } from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionGroup,
  AccordionSummary,
  Link,
  List,
  ListItem,
} from '@gusto/workbench';
import track from './track';

const AccountAlreadyExistsAccordion = () => {
  const [accordionOpen, setAccordionOpen] = useState(false);
  const accordionItems = [
    {
      id: 'try_demo',
      label: 'Try our demo',
      url: 'https://gusto.com/instant-demo',
    },
    {
      id: 'pricing',
      label: 'View plans and pricing',
      url: `https://gusto.com/product/pricing`,
    },
    {
      id: 'access_account',
      label: 'Trouble accessing your account',
      url: 'https://app.gusto.com/account_access/form',
    },
    {
      copy: 'Need more support? ',
      id: 'support',
      label: 'Visit our Help center',
      url: 'https://support.gusto.com',
    },
  ];

  const toggleAccordion = () => {
    setAccordionOpen(toggle => !toggle);
  };

  const onLinkClick = (_: any, data: string) => {
    track(data);
  };

  return (
    <AccordionGroup>
      <Accordion open={accordionOpen}>
        <AccordionSummary
          className="text-default-bold"
          value="additionalOptions"
          onClick={toggleAccordion}
        >
          Looking for something else?
          <span className="d-none d-md-inline">{' Let us help'}</span>
        </AccordionSummary>
        <AccordionDetails>
          <List>
            {accordionItems.map(item => {
              return (
                <ListItem key={item.id} className="account-already-exists__list_bullet_color">
                  {item.copy ? item.copy : ''}
                  <Link
                    href={item.url}
                    onClick={event => {
                      onLinkClick(event, item.id);
                    }}
                  >
                    {item.label}
                  </Link>
                </ListItem>
              );
            })}
          </List>
        </AccordionDetails>
      </Accordion>
    </AccordionGroup>
  );
};

export default AccountAlreadyExistsAccordion;
